export default __webpack_public_path__ + "static/media/gal5.b256e7a4.jpg";